import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './services/auth-guard/auth-guard.service';

const routes: Routes = [
	{
		path: '',
		redirectTo: 'home',
		pathMatch: 'full'
	},
	{
		path: 'home',
		loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule)
	},
	{
		path: 'areas',
		loadChildren: () => import('./pages/menu/areas/areas.module').then(m => m.AreasPageModule),
		canActivate: [AuthGuardService]
	},
	{
		path: 'lineitems',
		loadChildren: () => import('./pages/menu/line-items/line-items.module').then(m => m.LineItemsPageModule),
		canActivate: [AuthGuardService]
	},
	{
		path: 'trades',
		loadChildren: () => import('./pages/menu/tradesman/tradesman.module').then(m => m.TradesmanPageModule),
		canActivate: [AuthGuardService]
	},
	{
		path: 'keywords',
		loadChildren: () => import('./pages/menu/keywords/keywords.module').then(m => m.KeywordsPageModule),
		canActivate: [AuthGuardService]
	},
	{
		path: 'metattach',
		loadChildren: () => import('./pages/menu/metattach/metattach.module').then(m => m.MetattachPageModule),
		canActivate: [AuthGuardService]
	},
	{
		path: 'divisions',
		loadChildren: () => import('./pages/menu/divisions/divisions.module').then(m => m.DivisionsPageModule),
		canActivate: [AuthGuardService]
	},
	{
		path: 'suite16categories',
		loadChildren: () => import('./pages/menu/suite16categories/suite16categories.module').then(m => m.Suite16categoriesPageModule),
		canActivate: [AuthGuardService]
	},
	{
		path: 'shortlists',
		loadChildren: () => import('./pages/menu/shortlists/shortlists.module').then(m => m.ShortlistsPageModule),
		canActivate: [AuthGuardService]
	},
	{
		path: 'partners',
		loadChildren: () => import('./pages/menu/partners/partners.module').then(m => m.PartnersPageModule),
		canActivate: [AuthGuardService]
	},
	{
		path: 'base',
		loadChildren: () => import('./pages/base/base.module').then(m => m.BasePageModule)
	},
	{
		path: 'auth',
		loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthPageModule)
	},	{
		path: 'gamer-user-wallet-manager',
		loadChildren: () => import('./pages/menu/_gamer/gamer-user-wallet-manager/gamer-user-wallet-manager.module').then(m => m.GamerUserWalletManagerPageModule)
	},
	{
		path: 'gamer-user-wallet-transaction-manager',
		loadChildren: () => import('./pages/menu/_gamer/gamer-user-wallet-transaction-manager/gamer-user-wallet-transaction-manager.module').then(m => m.GamerUserWalletTransactionManagerPageModule)
	},
	{
		path: 'chat',
		loadChildren: () => import('./pages/menu/chat/chat.module').then(m => m.ChatPageModule)
	}


];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
	],
	exports: [RouterModule]
})
export class AppRoutingModule { }